// eslint-disable-next-line 
import lightGallery from "lightgallery";

const initGallery = () => {
    const galleryWrappers = document.querySelectorAll(".js-gallery-wrapper");
    if (galleryWrappers.length) {
        galleryWrappers.forEach((galleryWrapper) => {
            const openGalleryBtn = galleryWrapper.querySelector(".js-open-gallery-button");

            const gallery = lightGallery(galleryWrapper, {
                licenseKey: "a1f2b3c4d5e6f7g8h9i0",
                selector: ".js-gallery-image",
                download: false,
                zoom: false,
                share: false,
                mobileSettings: {
                    controls: true,
                },
            });

            window.shr = {
                gallery
            }

            if (openGalleryBtn) {
                openGalleryBtn.addEventListener("click", () => {
                    gallery.openGallery();
                });
            }
        });
    }
};

export default initGallery;
